/**
 * CR-6348: shared styling + layout primitives for the reworked SO Lines
 * filter panel (supplier view). Keeps the section components small and
 * visually consistent with the rest of the purchasing UI.
 *
 * CR-6401 rework: the section shell now comes from the app-wide filter
 * primitives so the purchasing panels, the dashboard and the quality panels
 * cannot drift apart — the filter-rework acceptance criteria require one
 * consistent layout across every view. These re-exports keep the existing
 * import sites working.
 *
 * CR-6347: updated to use the non-bare mode (with shaded header bar and icons)
 * to match the Pricebooks tab layout.
 */
import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { FilterSection as SharedFilterSection, FilterGrid } from '../../../../filters/FilterSection';

export const FIELD_CLS =
  'w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary';
export const LABEL_CLS = 'text-sm font-medium mb-2 block';

/**
 * A labelled group of related filters with a section heading.
 *
 * CR-6347: Now uses non-bare mode with shaded header bar and icon support
 * to match the Pricebooks tab layout.
 */
export function FilterSection({
  title,
  icon,
  children,
}: {
  title: string;
  icon?: LucideIcon;
  children: ReactNode;
}) {
  return (
    <SharedFilterSection title={title} icon={icon}>
      <FilterGrid>{children}</FilterGrid>
    </SharedFilterSection>
  );
}
